






















































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
	name: 'SidebarNav',

	props: {
		mobile: Boolean,
	},

	data: () => ({
		drawerOpen: false,
		logo: require('../assets/images/footy_logo_light.png'),
	}),

	computed: {
		...mapGetters(['currentUser']),
		route() {
			return this.$route.name;
		},
	},

	methods: {
		changeNav(name: string) {
			if (this.$store.getters.unsavedChanges) {
				if (confirm(`You have unsaved changes, Are you sure you want to continue. Unsaved changes will be lost`)) {
					this.drawerOpen = false;
					this.$store.commit('setUnsavedChanges', false);
					if (this.$route.name !== name) this.$router.push({ name });
				} else {
					this.drawerOpen = false;
				}
			} else {
				this.drawerOpen = false;
				if (this.$route.name !== name) this.$router.push({ name });
			}
		},

		toggleDrawer() {
			console.log('open drawer');
			this.drawerOpen = !this.drawerOpen;
		},
	},
});
